import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const About = () => {
  return (
    <section className="text-gray-600 body-font" id="about">
      <div className="flex md:flex-row flex-col items-center w-full h-full">
        <div className="container w-full md:max-w-xl md:mx-auto py-20 lg:pr-20 px-6 md:px-12 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center justify-center">
          <h1
            className="title-font sm:text-4xl md:text-5xl text-3xl mb-4 font-bold text-blue-800"
            data-aos="fade-right"
            data-aos-delay="400"
            data-aos-duration="500"
          >
            About Us
          </h1>
          <p
            className="mt-5 max-w-md md:max-w-lg  leading-loose"
            data-aos="fade-right"
            data-aos-delay="500"
            data-aos-duration="500"
          >
            SOLIDANA is a company specialized in industrial tires from Sri Lanka
            that offers all types of industrial tires such as Material handling
            tires, Construction tires with excellenet values, best performance
            and high quality. We strive to support our customers to meet their
            challenging tasks successfully by providing them with reliable,
            robust and durable products joined with a caring and dedicated
            services.
          </p>
        </div>
        <div
          className="w-full md:h-screen md:w-1/2"
          data-aos="zoom-in"
          data-aos-easing="ease-out-back"
          data-aos-duration="500"
        >
          <StaticImage
            className="object-cover object-center w-full h-full"
            alt="building"
            src="../images/about.jpg"
            width={680}
            height={680}
          />
        </div>
      </div>
    </section>
  )
}

export default About
